module.exports = __webpack_public_path__ + "img/slide-dog5.fddd89d8.png";